(function () {
  if (window.__wudyMotionBooted) return;
  window.__wudyMotionBooted = true;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function skipRevealMotion() {
    return (
      !document.body.classList.contains('template-index') &&
      window.matchMedia('(max-width: 749px)').matches
    );
  }

  function revealInScope(scope) {
    scope = scope || document;
    var nodes = scope.querySelectorAll('[data-wudy-reveal]:not(.is-wudy-visible)');
    if (!nodes.length) return;

    if (skipRevealMotion()) {
      nodes.forEach(function (el) {
        el.classList.add('is-wudy-visible');
      });
      return;
    }

    if (prefersReducedMotion()) {
      nodes.forEach(function (el) {
        el.classList.add('is-wudy-visible');
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (el) {
        el.classList.add('is-wudy-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-wudy-visible');
          observer.unobserve(entry.target);
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    nodes.forEach(function (el) {
      observer.observe(el);
    });
  }

  function boot(scope) {
    revealInScope(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot();
  });

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  window.WudyMotion = { reveal: boot };
})();
